import { useEffect, useRef } from 'react';
// import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

const IdleLogout = () => {
  const navigate = useNavigate();
  //   const dispatch = useDispatch();
  const timerRef = useRef(null);
  const idleTimeout = (Number(process.env.REACT_APP_IDLE_TIMEOUT_MINUTES) || 30) * 60 * 1000;
  const logout = () => {
    const token = localStorage.getItem('token');
    if (!token) return;
    localStorage.clear();
    toast.info('Session expired due to inactivity');
    navigate('/auth/login', { replace: true });
  };
  const resetTimer = () => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }
    timerRef.current = setTimeout(logout, idleTimeout);
    // timerRef.current = setTimeout(() => {
    //   console.log('Timeout Executed:', timerRef.current);
    //   logout();
    // }, idleTimeout);
    // console.log('Logout time:', new Date(Date.now() + idleTimeout));
  };

  useEffect(() => {
    const events = ['mousemove', 'mousedown', 'keypress', 'scroll', 'touchstart', 'click'];

    events.forEach((event) => window.addEventListener(event, resetTimer));
    resetTimer();
    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
      events.forEach((event) => window.removeEventListener(event, resetTimer));
    };
  }, []);
  return null;
};
export default IdleLogout;
